import { useDeviceType } from '@cian/ui-kit';
import { FC, useState, useCallback, useRef, useEffect } from 'react';

import { NewPromo } from 'shared/components/NewPromo';

interface INewPromoContainerProps {
  title: string;
  subtitle: string;
}

export const NewPromoContainer: FC<INewPromoContainerProps> = props => {
  const [loaded, setLoaded] = useState(false);
  const imageRef = useRef<HTMLImageElement>(null);
  const handleLoad = useCallback(() => setLoaded(true), []);
  const device = useDeviceType();

  useEffect(() => {
    if (imageRef.current?.complete) {
      setLoaded(true);
    }
  }, []);

  return <NewPromo {...props} device={device} loaded={loaded} onLoad={handleLoad} imageRef={imageRef} />;
};
